export default __webpack_public_path__ + "static/media/blog3.b13dd6a4.jpg";